import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import './index.css'
import './index.rtl.css'
import './App.scss';
import {Helmet} from "react-helmet";
import {setAccessToken} from "./utils/MyApi";
import MySpinner from "./utils/MySpinner";
import Forget from "./components/Auth/Forget";


const loading = () => <div className="animated fadeIn pt-3 text-center"><MySpinner/></div>;

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./components/Auth/Login'));
const Impersonate = React.lazy(() => import('./components/Auth/Impersonate'));
//const Page404 = React.lazy(() => import('./views/Pages/Page404'));
//const Page500 = React.lazy(() => import('./views/Pages/Page500'));

class App extends Component {


  constructor(props) {

    super(props);

    setAccessToken(localStorage.getItem('apiToken'));

    let lang = localStorage.getItem('lang') || 'fa';
    let direction = localStorage.getItem('dir') || 'rtl';
    this.state = {
      lang: lang,
      direction: direction
    }
  }
  componentDidMount() {
    let iframe = document.querySelector("body > iframe");
    if (!!iframe) {
      // delete the iframe element
      iframe.parentNode.removeChild(iframe);
    }
  }



  render() {
    return (

      <>
        <Helmet htmlAttributes={{lang: this.state.lang, dir: this.state.direction}}/>
        <BrowserRouter>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>}/>
              <Route exact path="/forget" name="Forget Password" render={props => <Forget {...props}/>}/>
              <Route exact path="/impersonate/:token" name="Impersonate Login" render={props => <Impersonate {...props}/>}/>
              <Route path="/" name="Home" render={props => <DefaultLayout {...props}/>}/>
            </Switch>
          </React.Suspense>
        </BrowserRouter>
      </>

    );
  }
}

export default App;
